<svelte:options customElement={{
	tag: "bt-practice-sidebar-toggle",
	shadow: 'none'
}} />

<script lang="ts">
	import { onMount } from 'svelte';
	import { eventBus } from '$shared/lib/eventBus';

	export let toggletext: string = 'Chat with AI Practice';

	const sendOpenPractice = (uid) => {
		eventBus.emit('practice-open');
	}

	let button: any;

	$: circleX = -300;
	$: circleY = -300;

	onMount(() => {
		button.addEventListener('pointermove', (event: PointerEvent) => {
			circleX = event.offsetX - 150;
			circleY = event.offsetY - 150;
		});
		return () => {
			button.removeEventListener('pointermove');
		}
	});

</script>

<button on:click={sendOpenPractice} bind:this={button} style={`--circle-x: ${circleX}px; --circle-y: ${circleY}px`}>
	<div class="ai-loader">
	  <div class="ai-loader__cube">
	    <div class="ai-loader__cube__face ai-loader__cube__face--front"></div>
	    <div class="ai-loader__cube__face ai-loader__cube__face--back"></div>
	    <div class="ai-loader__cube__face ai-loader__cube__face--left"></div>
	    <div class="ai-loader__cube__face ai-loader__cube__face--right"></div>
	    <div class="ai-loader__cube__face ai-loader__cube__face--top">
	      <div class="ai-loader__cube__plus--square ai-loader__cube__plus--square--vertical"></div>
	      <div class="ai-loader__cube__plus--square ai-loader__cube__plus--square--horizontal"></div>
	      <div class="ai-loader__cube__plus--square ai-loader__cube__plus--square--inner"></div>
	    </div>
	    <div class="ai-loader__cube__face ai-loader__cube__face--bottom"></div>
	  </div>
	</div>
	<span>{toggletext}</span>
</button>

<style>
	button {
		border-radius: 2rem;
		height: 3.5rem;
		width: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		gap: theme('spacing.3');
		background: theme('colors.space-blue-light');
		box-shadow: 0 6px 10px -4px rgba(2, 27, 135, 0.20), 0 3px 20px 0 rgba(2, 27, 135, 0.10), 0 4px 8px 2px rgba(2, 27, 135, 0.02);
		position: relative;
		background: radial-gradient(circle at center, rgba(255, 100, 255, 1), rgba(255, 255, 255, .5), transparent, transparent) var(--circle-x) var(--circle-y) / 300px 300px no-repeat, linear-gradient(0deg, #EEF1FF, #EEF1FF);
		background-blend-mode: hue;
	}
	.ai-loader, span {
		pointer-events: none;
		&:hover {
			cursor: pointer;
		}
	}
	span {
		display: block;
		font-size: theme('fontSize.sm');
		font-weight: 500;
	}
	.ai-loader {
		transform: scale(.8);
	}
</style>
